<template>
  <div class="menu" :style="{ 'background-color': '#442E77' }">
    <img src="../../static/img/cancel_menu.svg" @click="$router.go(-1)" class="menu-close" v-bind:style="{'margin-top':this.mobileSite.closeMenuTop, 'margin-right':this.mobileSite.closeMenuRight}">

    <div v-if="!this.isMobile">
      <div class="menu-option-div">

        <table>
          <tr >
            <td class="menu-table-left">
              <div class="menu-option" v-for="(menuOption, index) in menuOptions"
                   @click="chooseOption(index)">
                {{ menuOption }}
              </div>
            </td>
            <td class="menu-table-middle"></td>
            <td class="menu-table-right">

              <img class="menu-white-img" src="/static/img/global/hippo_logo_white.svg">
              <div class="menu-social-line">
                <a href="https://www.facebook.com/hippotec.mobile/">
                  <img class="menu-social-line-item" src="/static/img/global/global-menu-facebook-white.svg">
                </a>
                <a href="https://www.linkedin.com/company/hippotec-ltd-/about/">
                  <img class="menu-social-line-item" src="/static/img/global/global-menu-linkedin-white.svg">
                </a>
                <a href="https://www.instagram.com/hippotec_ltd/">
                  <img class="menu-social-line-item" src="/static/img/global/global-menu-instagram-white.svg">
                </a>
              </div>
              <div class="menu-address">
                +972-3-6565400  Marketing@hippotec.com
                25, Ha-sivim st., Petah Tikva, Israel
              </div>
              <button @click="onLetsTalkPressed" class="menu-submit-button">LET'S TALK</button>
            </td>
          </tr>
        </table>


      </div>
    </div>
    <div v-else>
      <div class="mobile-menu">
        <div class="menu-option-mobile" v-for="(menuOption, index) in menuOptions"
             @click="chooseOption(index)">
          {{ menuOption }}
        </div>
        <div class="mobile-menu-address">
          +972-3-6565400 <br>
          Marketing@hippotec.com <br>
          25, Ha-sivim st., Petah Tikva, Israel
        </div>
        <div class="mobile-menu-social-line">
          <a href="https://www.facebook.com/hippotec.mobile/">
            <img class="mobile-menu-social-line-item" src="/static/img/facebook_white.svg">
          </a>
          <a href="https://www.linkedin.com/company/hippotec-ltd-/about/">
            <img class="mobile-menu-social-line-item" src="/static/img/linkedin_white.svg">
          </a>
          <a href="https://www.instagram.com/hippotec_ltd/">
            <img class="mobile-menu-social-line-item" src="/static/img/instagram_white.svg">
          </a>
        </div>

        <button @click="onLetsTalkPressed" class="mobile-menu-submit-button">LET'S TALK</button>


      </div>
    </div>

  </div>
</template>
<script>
  import menuMobileBackground from "../../static/img/menuMobile.png"

  export default {
    name: 'Menu',
    data() {
      return {
        mobileSite: {
          closeMenuRight: "50px",
          closeMenuTop: "50px",
        },
        isMobile: false,
//        image: menuBackground,
//        menuOptions: ["HOME", "PROJECTS", "CUSTOMERS", "ABOUT US", "CAREERS", "CONTACT"],
        menuOptions: ["WHAT WE DO", "OUR WORK", "ABOUT US", "CAREERS", "OUR CUSTOMERS", "CONTACT"],
        optionIndex: -99,
        window
      }
    },
    methods:
      {
        prepareMobile(isMobile) {
          //console.log(isMobile);
          this.isMobile = isMobile;
          if (isMobile) {
            this.mobileSite.closeMenuRight = "20px";
            this.mobileSite.closeMenuTop = "20px";
          }
        },
        onLetsTalkPressed: function() {
          this.$router.push('contactus')
        },
        hoverOption: function (index) {
          if (window.innerWidth > 600) {
            this.optionIndex = index
          }
        },
        chooseOption: function (index) {
          switch (this.menuOptions[index]) {
            case "WHAT WE DO":
              this.$router.push('what-we-do')
              break;
            case "OUR WORK":
              this.$router.push('projects')
              break;
            case "OUR CUSTOMERS":
              this.$router.push('our-customers')
              break;
            case "ABOUT US":
              this.$router.push('whoarewe')
              break;
            case "CAREERS":
              this.$router.push('career')
              break;
            case "CONTACT":
              this.$router.push('contactus')
              break;
            default:
              break;
          }
        }
      },
    created() {
      //console.log(window);
      //this.image = window.innerWidth > 600 ? menuBackground : menuMobileBackground
      this.prepareMobile(localStorage.isMobile == 'true');
    }
  }

</script>
<style lang="scss">
  @import "../assets/scss/menu.scss";
  .menu-close
  {
    float: right;
/*    margin-top: 50px;
    margin-right: 50px;*/
    width: 50px;
    height: 50px;
    cursor: pointer;
    animation: menuclose-icon-left 1s forwards 1s;
  }
  .mobile-menu {
    margin-top: 80px;
  }
  .mobile-menu-social-line-item {
    margin-right: 5px;
    margin-left: 5px;
    width: 50px;
  }
  .mobile-menu-submit-button
  {
    display: table;
    margin: 0 auto;
    margin-top: 30px;
    width: 150px;
    height: 40px;
    color: #fff;
    cursor: pointer;
    font-weight: 500;
    border-radius: 2.7px;
    background: transparent;
    border: 1px solid #fff;
  }
  .mobile-menu-social-line {
    text-align: center;
    margin-top: 27px;
  }
  .menu-option-mobile {
    margin-left: 20px;
    font-weight: 500;
    font-family: Rubik, sans-serif;
    margin-bottom: 5px;
    font-size: 40px;
    color: #ffffff;
    cursor: pointer;
  }
  .mobile-menu-address {
    margin-top: 20px;
    text-align: center;
    font-family: Rubik, sans-serif;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.72;
    letter-spacing: normal;
    color: var(--white);
  }
</style>




// WEBPACK FOOTER //
// src/pages/Menu.vue